module.exports = __webpack_public_path__ + "static/media/13-kirurgi.192d9088.mp3";